export const exploreCardStyles = {
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    p: 3
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    mb: 2
  },
  icon: {
    fontSize: 24,
    mr: 1,
    color: 'rgb(0, 184, 217)'
  },
  title: {
    color: 'rgb(255, 255, 255)',
    fontWeight: 700,
    fontSize: '0.875rem',
    fontFamily: "'Plus Jakarta Sans', sans-serif"
  },
  description: {
    color: 'rgb(145, 158, 171)',
    fontSize: '0.875rem',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    mb: 3,
    flexGrow: 1
  },
  button: {
    alignSelf: 'flex-start',
    color: 'rgb(0, 184, 217)',
    borderColor: 'rgba(0, 184, 217, 0.24)',
    textTransform: 'none',
    fontWeight: 700,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontSize: '0.875rem',
    minHeight: 36,
    px: 2,
    py: 0.5,
    borderRadius: 1,
    '&:hover': {
      borderColor: 'rgba(0, 184, 217, 0.32)',
      background: 'rgba(0, 184, 217, 0.08)'
    }
  }
}; 